import {ValueObject} from '@s-ui/domain'

export class LatestModelValueObject extends ValueObject {
  /**
   * @param {Number} financedOfferPrice
   * @param {String} image
   * @param {String} make
   * @param {Number} makeId
   * @param {String} model
   * @param {Number} modelId
   * @param {Number} price
   * @param {Number} offerPrice
   * @param {String} url
   * */
}
